export enum ConfigurationEnvironmentEnum {
  DEVELOPMENT = "development",
  PRODUCTION = "production",
}

export type Configuration = {
  environment: ConfigurationEnvironmentEnum | null;
  firebaseVapidKey: string | null;
  modules: {
    icnea: boolean;
    rentalready: boolean;
    hostaway: boolean;
  };
};
